import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { stripeGetApiText } from '../services/stripeApi';
import {
  stripeKeyFailed,
  getStripeKey as GET_STRIPE_KEY,
  stripeClientSecretFailed,
  stripeClientSecretLoaded,
  stripeErrorAttempt as STRIPE_ERROR_ATTEMPT,
  stripeKeyLoaded,
  stripeInitialDataLoaded,
} from '../actions';
import {
  apiCallWithApiKey,
  getStorageOrDefault,
} from '../services/api';
import { USER_INFO_KEY } from '../services/constants';
import { PETCLOUD_ORIGIN } from '../hooks/useRecaptchaValidator';

export function* getStripePublishableKey() {
  const path = 'publishable-key';
  const response = yield call(stripeGetApiText, path);

  if (response.ok) {
    yield put(stripeKeyLoaded(response.data));
  } else {
    yield put(stripeKeyFailed({
      message: response?.message,
      path: `${process.env.REACT_APP_API_URL}/${path}`,
      request: '',
      response: JSON.stringify(response?.data || ''),
      status: response?.status,
    }));
  }
}

export function* getStripeClientSecret({ policy, token }) {
  const userInfo = yield call(getStorageOrDefault, USER_INFO_KEY);

  if (!userInfo) {
    yield put(stripeClientSecretFailed());

    return;
  }

  const { FirstName, LastName, LoginEmail } = userInfo;
  const DiamondClientId = userInfo?.DiamondClientId;

  const body = {
    DiamondClientId,
    email: LoginEmail,
    metadata: {
      additionalProp1: String(userInfo?.CustomerId),
      additionalProp2: String(DiamondClientId),
    },
    name: `${FirstName} ${LastName}`,
    origin: PETCLOUD_ORIGIN,
    PolicyId: String(policy),
    token,
  };

  const requestOptions = {
    body,
    method: 'POST',
  };
  const path = 'purchase/payments/setup-intent';

  const response = yield call(apiCallWithApiKey, path, requestOptions);

  if (response.success) {
    yield put(stripeClientSecretLoaded(response?.clientSecret));
  } else {
    yield put(stripeKeyFailed({
      message: response?.message,
      path: `${process.env.REACT_APP_API_URL}/${path}`,
      request: JSON.stringify(body),
      response: JSON.stringify(response),
      status: response?.status,
    }));
  }
}

export function* getStripeKey({ payload }) {
  const store = yield select(({ billingPayments }) => (billingPayments));

  const { stripeKey } = store;

  if (!stripeKey) {
    yield call(getStripePublishableKey);
  }

  yield call(getStripeClientSecret, payload);

  yield put(stripeInitialDataLoaded());
}

export function* stripeLogError({ payload }) {
  const { email, endpoint, error, requestString, responseString } = payload;

  yield call(
    apiCallWithApiKey,
    'purchase/Log/QuoteSiteError',
    {
      body: {
        Action: 'Petcloud Stripe error',
        Email: email,
        Endpoint: endpoint,
        ErrorDescription: `Petcloud catch ${error}`,
        // Not compatible with all browsers
        OperatingSystem: navigator?.userAgentData?.platform,
        Request: requestString,
        Response: responseString,
        UserAgent: navigator.userAgent,
      },
      method: 'POST',
    },
  );
}

export function* stripeSaga() {
  yield all([
    takeLatest(GET_STRIPE_KEY, getStripeKey),
    takeLatest(STRIPE_ERROR_ATTEMPT, stripeLogError),
  ]);
}
